<template lang="pug">
ods-form.login__form(
  :model="loginForm",
  :rules="rules",
  ref="loginForm",
  :hide-required-asterisk="true"
)
  div(
    v-loading="loading && !mobile",
    v-loading.fullscreen.lock="loading && mobile",
    v-if="this.showForm"
  )
    h1.login__form__title {{ $t('login.title') }}
    .login__form__errors
      ods-alert(
        v-show="errors",
        :title="errorInfo || $t('login.loginError')",
        type="error",
        :closable="false"
      )

    ods-form-item(:label="$t('login.user')", prop="user")
      ods-input(
        :class="{ error: errors }",
        type="text",
        v-model="loginForm.user"
      )

    .login__form__label-pass
      label(for="password") {{ $t('login.password') }}
      router-link(
        to="/login/password"
        custom
        v-slot="{ href, navigate }"
      )
        a(
          :href="href"
          @click="navigate"
          @keypress.enter="navigate"
          v-if="showForgot"
          role="link"
        ) {{ $t('login.forgotPassword') }}

    ods-form-item(prop="password")
      ods-input(
        :class="{ error: errors }",
        type="password",
        v-model="loginForm.password",
        show-password
      )
    ods-select(
      v-model='application'
      v-if="isLogged && isMultipleApp"
      @change="handleChangeApplication"
      placeholder='Seleccionar Aplicación',
      selectLabel='Aplicaciones',
      size='exa')
      ods-option(
        v-for='item in options'
        :key='item.value'
        :label='item.label'
        :value='item.value'
      )

    .login__form__actions
      ods-checkbox(
        v-model="keepMeLogged"
        v-if="showKeepMeLogged"
      ) {{ $t('login.keepMeLogged') }}
      ods-button(
        v-if="!isLogged"
        size="large",
        native-type="submit",
        @click.prevent="submitForm('loginForm')"
      ) {{ $t('login.login') }}

    .login__form__register
      span(v-if="showRegister") {{ $t('login.register.account') }}
        router-link(
          to="/login"
          custom
          v-slot="{ href, navigate }"
        )
          a(
            :href="href"
            @click="navigate"
            @keypress.enter="navigate"
            role="link"
          ) {{ $t('login.register.register') }}
  ods-module.ods-dashboard(
    v-if="this.showAccess",
    v-loading="loading && !mobile",
    v-loading.fullscreen.lock="loading && mobile"
  )
    h2.ods-dashboard__title Accediendo a la Aplicación...
    .ods-dashboard__desc
      p Está usted accediendo a la aplicación, estamos cargando el Entorno, en breves segundos será redirigido...
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { HTTP_PLATFORM } from '../../store/modules/http'
export default {
  name: 'LoginForm',
  data () {
    return {
      loginForm: {
        user: '',
        password: ''
      },
      rules: {
        user: [
          { required: true, message: this.$t('login.rules.user'), trigger: 'submit' }
        ],
        password: [
          { required: true, message: this.$t('login.rules.password'), trigger: 'submit' }
        ]
      },
      options: [],
      application: '',
      isLogged: false,
      isMultipleApp: false,
      showForgot: true,
      showRegister: true,
      showKeepMeLogged: true,
      keepMeLogged: true,
      errors: false,
      errorInfo: '',
      showForm: true,
      showAccess: false
    }
  },
  methods: {
    ...mapActions([
      'login',
      'preLogin',
      'loader',
      'getRealmData',
      'getUserData',
      'getI18nData',
      'getConfiguration',
      'setCurrentApplication',
      'loadAvailableApplications',
      'loadEnvironment',
      'resetGlobalFilters'
    ]),

    // SUBMIT LOGIN FORM
    submitForm (formName) {
      // remove previous data in session
      sessionStorage.clear()
      // validation
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loader({ loader: true })
          const data = {
            username: this.loginForm.user,
            password: this.loginForm.password
          }
          // first default login to get user and procceed with available Applications
          const user = await this.preLogin(data)
          const isError = user instanceof Error

          // IF PRELOGIN OK
          if (!isError) {
            this.$notify.closeAll()
            this.isLogged = true
            console.log('user info: ', JSON.stringify(user))
            HTTP_PLATFORM.defaults.headers.common.Authorization = 'Bearer ' + user.data.access_token

            // GET CONFIGURATION
            const configuration = await this.getConfiguration()

            // check available Apps for user
            const availableApps = await this.loadAvailableApplications()
            console.log('Available Apps: ', JSON.stringify(availableApps))

            // To-Do: encapsular esté código
            // handleConfiguration:
            // mount application selector or directly load application information (just only 1 App.)
            const nApps = configuration.filter(function (obj) { return availableApps.indexOf(obj.realmId) !== -1 }).map(({ realmId, title }) => ({ value: realmId, label: title }))
            if (nApps.length === 0) {
              // TO-DO: ver que hacer cuando no hayan aplicaciones, en principio error de acceso.
            } else if (nApps.length === 1) {
              // 1 APP directly load this app.
              console.log('JUST ONE APP: ', JSON.stringify(nApps))
              this.isMultipleApp = false
              this.$notify({
                title: 'Accediendo a ' + nApps[0].label + ':',
                message: 'Este Usuario solo tiene esta Aplicación disponible, cargando su entorno...',
                type: 'success',
                iconClass: 'ods-icon-multiple',
                duration: 6000,
                position: 'top-right',
                showClose: true
              })
              const selectedApp = configuration.filter(x => x.realmId === nApps[0].value).map(y => y.realmId)[0]
              this.setCurrentApplication(selectedApp) // set current App.
              this.handleChangeApplication(selectedApp)
            } else {
              // +1 App so load the App selector to select one and load it
              this.options = nApps
              this.isMultipleApp = true
              this.$notify({
                title: 'Selección de Aplicaciones:',
                message: 'Este Usuario tiene varias Aplicaciones Disponibles, por favor seleccione a cual quiere acceder...',
                type: 'success',
                iconClass: 'ods-icon-multiple',
                duration: 30000,
                position: 'top-right',
                showClose: true
              })
            }
            this.loader({ loader: false })
          } else {
            console.log('error retriving User Data...')
            this.$notify({
              title: 'Error de Logado',
              message: 'Revise el usuario y password suministrados, y pruebe de nuevo.',
              type: 'error',
              iconClass: 'ods-icon-error-alert',
              duration: 4000,
              position: 'top-right',
              showClose: true
            })
            this.loader({ loader: false })
          }
        } else {
          console.log('error submit!!')
          this.errors = true
          this.loader({ loader: false })
          return false
        }
      })
    },
    // handleChangeApplication: application selector, on Change launch login against this App.
    async handleChangeApplication (app) {
      var that = this
      var isaChangeOfApp = localStorage.getItem('accessAppRequest') !== null
      this.loader({ loader: true })
      this.resetGlobalFilters() // reset filters configuration.
      var config = this.getCurrentConfiguration
      var appConfig = config.length > 0 ? config.filter(x => x.realmId === app)[0] : {}

      // set current App
      this.setCurrentApplication(app)

      // add user to App conf to use as payload or get from app if is a multi-app change application process
      const user = that.loginForm.user !== '' ? that.loginForm.user : config.find(o => o.username !== '').username
      const pass = that.loginForm.password !== '' ? that.loginForm.password : config.find(o => o.password !== '').password
      this.$set(appConfig, 'username', user)
      this.$set(appConfig, 'password', pass)

      // make app-login and load environment
      const userApp = await this.login(appConfig)
      const isAppError = userApp instanceof Error

      // IF APP-LOGIN OK
      if (!isAppError) {
        this.$notify.closeAll()
        HTTP_PLATFORM.defaults.headers.common.Authorization = 'Bearer ' + userApp.data.access_token
        sessionStorage.setItem('sessionToken', userApp.data.access_token)
        console.log('APP USER: ', JSON.stringify(userApp))
        this.$set(appConfig, 'role', userApp.data.authorities[0])

        // LOAD APP i18n
        const i18nPlatform = await this.getI18nData(this)
        console.log('|--> Available App I18n:', JSON.stringify(i18nPlatform))

        // LOAD APP ENVIRONMENT
        const environment = await this.loadEnvironment(appConfig)
        const isEnvironmentError = environment instanceof Error
        if (!isEnvironmentError) {
          console.log('environment cargado... routear')
          this.$router.push({ name: 'Dashboard', params: { dashboardId: environment } }).catch(() => {}) // catch cause environment is a promise
          this.loader({ loader: false })
          if (isaChangeOfApp) {
            // remove change app request if it is a change of Application Proccess, its finished.
            localStorage.removeItem('accessAppRequest')
          }
        } else {
          console.log('error carga environment')
        }
      } else {
        console.log('error nuevo login')
      }
    },
    accessToApp () {
      console.log('Checking Access to APP...')
      this.loader({ loader: false })
      if (localStorage.getItem('accessAppRequest')) {
        console.log('There an Access APP request, hide login form , show access card, and launch APP configuration...')
        this.showForm = false
        this.showAccess = true
        console.log('APP INFO: ', JSON.stringify(this.availableApps))
        var accessData = JSON.parse(localStorage.getItem('accessAppRequest'))
        this.handleChangeApplication(accessData.realm)
      } else {
        console.log('There NO Access APP request, so loading login form...')
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoaderState',
      mobile: 'isMobile',
      loginType: 'getLoginType',
      realm: 'getRealmInfo',
      availableApps: 'getRealmsApp',
      getCurrentConfiguration: 'getCurrentConfiguration'
    })
  },
  mounted: function () {
    this.accessToApp()
  }
}

</script>

<style lang="scss" scoped>
.login__form {
  width: 100%;
  padding-top: $space-700;

  @include mediaXs {
    max-width: rem(300);
  }

  /* login title & description */

  &__title {
    @include txt-body-600;
    text-align: center;
    padding-bottom: $space-400;
  }

  &__description {
    @include txt-body-300;
    padding-bottom: $space-300;
  }

  /* label password */

  &__label-pass {
    display: flex;
    @include txt-body-200;
    color: var(--color-txt-secondary);
    padding-bottom: $space-050;

    & > a {
      color: var(--color-txt-interactive);
      margin-left: auto;
      transition: 0.3s all ease;

      &:hover {
        color: var(--color-bg-hover);
      }
    }
  }

  /* Input differences */

  .ods-input {
    &__inner {
      height: rem(40);
    }
    &__suffix {
      height: rem(40);

      .ods-input__icon.ods-icon-eye {
        font-size: rem(22);
      }
    }
  }

  /* Actions */

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: $space-700;
  }

  /* Errors */

  &__errors {
    margin-bottom: $space-300;
  }

  /* Register */

  &__register {
    margin-top: $space-400;
    padding-top: $space-300;
    border-top: $border-size-200 dotted var(--color-border-hard-divisor);
    @include txt-body-500;
    text-align: center;

    & > a {
      color: var(--color-txt-interactive);
      margin-left: $space-200;
      transition: 0.3s all ease;

      &:hover {
        color: var(--color-bg-hover);
      }
    }
  }
}
</style>
